/**
 * Geo detection helpers.
 *
 * `window.USER_COUNTRY` (2-letter ISO code) is set by an external script
 * (https://geo-detect.lunai.care/geo.js, loaded in index.html). It usually resolves long
 * before the paywall, but `waitForGeoCountry` lets callers await it with a bounded timeout
 * (mirrors the wait in ConsentManager). Used to pick the local checkout currency.
 */

/** The detected 2-letter country code, or undefined if geo hasn't resolved yet. */
export function getDetectedCountry(): string | undefined {
  return window.USER_COUNTRY;
}

/**
 * Wait up to `timeoutMs` for geo detection to populate `window.USER_COUNTRY`. Resolves with
 * the country code (or undefined on timeout). Returns immediately if already detected.
 */
export async function waitForGeoCountry(timeoutMs: number = 3000): Promise<string | undefined> {
  const start = Date.now();
  while (window.USER_COUNTRY === undefined && Date.now() - start < timeoutMs) {
    await new Promise((resolve) => setTimeout(resolve, 100));
  }
  return window.USER_COUNTRY;
}
